import { Component, OnInit, Input } from '@angular/core';
import { PageContentService } from 'src/services/pagecontent.service';

@Component({
    selector: 'app-social-icons',
    templateUrl: './social-icons.component.html',
    styleUrls: ['./social-icons.component.scss']
})
export class SocialIconsComponent implements OnInit {
    @Input() iconSize: string = '';
    @Input() iconColor: string = '';
    isSocialIcon:boolean;
    socialIconcheck: any;
    public siteConfigList: any[];
    constructor(public pageservice: PageContentService) { }

    ngOnInit() {
        this.siteConfigList = [];
        this.getSiteConfig();
    }
    getSiteConfig() {
        this.pageservice.getSiteconfig().subscribe(result => {
            
            if (result != null) {
                this.siteConfigList = result;
                this.socialIconcheck=result.socialIcon.filter(i=>i.isactive==true);
                this.isSocialIcon=result.isSocialIcon;

            }
        });
    }

}
